// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__6FzDo","checkboxLabel":"Checkbox_checkboxLabel__PA7ro"};